import getPausedFromList from '@/services/api/internal/eDispatch/pause.api';

const registerModule = (store) => {
  store.registerModule(['requests', 'paused', 'count'], {
    namespaced: true,
    state: {
      result: null,
      request: null,
      isLoading: false,
      error: null,
    },
    getters: {
      result: (state) => state.result,
      isLoading: (state) => state.isLoading,
      error: (state) => state.error,
    },
    mutations: {
      SET_REQUEST: (state, request) => {
        state.result = null;
        state.request = request;
        state.isLoading = true;
        state.error = null;
      },
      SET_RESULT: (state, result) => {
        state.result = result;
        state.request = null;
        state.isLoading = false;
      },
      SET_ERROR: (state, error) => {
        state.request = null;
        state.isLoading = false;
        state.error = error;
      },
    },
    actions: {
      getCount({ commit, rootGetters }) {
        const entities = rootGetters['entities/current'].map(
          (item) => item.nav_full_id
        );
        getPausedFromList(entities)
          .then((result) => {
            commit('SET_RESULT', result.count);
          })
          .catch((error) => {
            commit('SET_ERROR', error);
          });
      },
    },
  });

  store.subscribe((mutation) => {
    if (mutation.type === 'entities/SET_CURRENT') {
      store.dispatch('requests/paused/count/getCount');
    }
  });

  store.subscribeAction((action) => {
    if (action.type === 'requests/paused/refreshItems') {
      store.dispatch('requests/paused/count/getCount');
    }
  });

  if (store.getters['boilerplate/isInit']) {
    store.dispatch('requests/paused/count/getCount');
  }
};

export default registerModule;
